module.exports = __webpack_public_path__ + "static/media/cloud.462b2b4b.png";